import React from 'react';
import { useNavigate } from 'react-router-dom';

const Home = ({ isDesktop }) => {
  const navigate = useNavigate();

  return (
    <div className={`text-center py-12 ${isDesktop ? "max-w-6xl mx-auto" : ""}`}>
      <h1 className="text-4xl sm:text-5xl font-extrabold mb-4 tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-slate-100 via-cyan-400 to-indigo-300">
        Control de Asistencia
      </h1>
      <p className="text-base sm:text-lg text-slate-400 mb-12 max-w-2xl mx-auto">
        Panel administrativo y escaneo de códigos QR para el control horario de
        Negocios Peña E.I.R.L.
      </p>

      <div className={`grid gap-6 ${isDesktop ? "grid-cols-3 xl:grid-cols-5" : "grid-cols-1 md:grid-cols-2"}`}>
        <button
          onClick={() => navigate("/registro")}
          className="glass-card glass-card-hover glow-cyan p-8 rounded-2xl flex flex-col justify-between h-64 text-center group cursor-pointer"
        >
          <div className="text-cyan-400 mb-4 transition-transform duration-300 group-hover:scale-110">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto filter drop-shadow-[0_0_8px_rgba(34,211,238,0.2)]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-bold text-slate-100 group-hover:text-cyan-400 transition-colors mb-2">
              Registro de Empleados
            </h3>
            <p className="text-xs text-slate-400">
              Registra nuevos colaboradores y genera sus credenciales QR de ingreso.
            </p>
          </div>
          {isDesktop && (
            <div className="mt-4 text-[10px] text-slate-500 font-mono tracking-wider flex justify-center gap-1">
              <kbd className="bg-slate-950 px-1.5 py-0.5 rounded border border-slate-800">Ctrl</kbd> + 
              <kbd className="bg-slate-950 px-1.5 py-0.5 rounded border border-slate-800">2</kbd>
            </div>
          )}
        </button>

        <button
          onClick={() => navigate("/scanner")}
          className="glass-card glass-card-hover glow-green p-8 rounded-2xl flex flex-col justify-between h-64 text-center group cursor-pointer"
        >
          <div className="text-emerald-400 mb-4 transition-transform duration-300 group-hover:scale-110">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto filter drop-shadow-[0_0_8px_rgba(16,185,129,0.2)]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-bold text-slate-100 group-hover:text-emerald-400 transition-colors mb-2">
              Escáner de Asistencia
            </h3>
            <p className="text-xs text-slate-400">
              Registra en tiempo real las entradas y salidas mediante código QR.
            </p>
          </div>
          {isDesktop && (
            <div className="mt-4 text-[10px] text-slate-500 font-mono tracking-wider flex justify-center gap-1">
              <kbd className="bg-slate-950 px-1.5 py-0.5 rounded border border-slate-800">Ctrl</kbd> + 
              <kbd className="bg-slate-950 px-1.5 py-0.5 rounded border border-slate-800">3</kbd>
            </div>
          )}
        </button>

        <button
          onClick={() => navigate("/admin")}
          className="glass-card glass-card-hover glow-purple p-8 rounded-2xl flex flex-col justify-between h-64 text-center group cursor-pointer"
        >
          <div className="text-purple-400 mb-4 transition-transform duration-300 group-hover:scale-110">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto filter drop-shadow-[0_0_8px_rgba(168,85,247,0.2)]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-bold text-slate-100 group-hover:text-purple-400 transition-colors mb-2">
              Panel Administrativo
            </h3>
            <p className="text-xs text-slate-400">
              Consulta registros diarios, exporta asistencias e inspecciona personal.
            </p>
          </div>
          {isDesktop && (
            <div className="mt-4 text-[10px] text-slate-500 font-mono tracking-wider flex justify-center gap-1">
              <kbd className="bg-slate-950 px-1.5 py-0.5 rounded border border-slate-800">Ctrl</kbd> + 
              <kbd className="bg-slate-950 px-1.5 py-0.5 rounded border border-slate-800">4</kbd>
            </div>
          )}
        </button>

        <button
          onClick={() => navigate("/gafetes")}
          className="glass-card glass-card-hover glow-cyan p-8 rounded-2xl flex flex-col justify-between h-64 text-center group cursor-pointer border-slate-800/80"
        >
          <div className="text-blue-400 mb-4 transition-transform duration-300 group-hover:scale-110">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto filter drop-shadow-[0_0_8px_rgba(96,165,250,0.2)]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-bold text-slate-100 group-hover:text-blue-400 transition-colors mb-2">
              Gafetes de Empleados
            </h3>
            <p className="text-xs text-slate-400">
              Visualiza y descarga los códigos QR de todos los trabajadores.
            </p>
          </div>
          {isDesktop && (
            <div className="mt-4 text-[10px] text-slate-500 font-mono tracking-wider flex justify-center gap-1">
              <kbd className="bg-slate-950 px-1.5 py-0.5 rounded border border-slate-800">Ctrl</kbd> + 
              <kbd className="bg-slate-950 px-1.5 py-0.5 rounded border border-slate-800">5</kbd>
            </div>
          )}
        </button>

        <button
          onClick={() => navigate("/portal")}
          className="glass-card glass-card-hover glow-indigo p-8 rounded-2xl flex flex-col justify-between h-64 text-center group cursor-pointer border-slate-800/80"
        >
          <div className="text-indigo-400 mb-4 transition-transform duration-300 group-hover:scale-110">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto filter drop-shadow-[0_0_8px_rgba(99,102,241,0.2)]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-bold text-slate-100 group-hover:text-indigo-400 transition-colors mb-2">
              Portal del Empleado
            </h3>
            <p className="text-xs text-slate-400">
              Autoconsulta de asistencia y horarios para colaboradores.
            </p>
          </div>
          {isDesktop && (
            <div className="mt-4 text-[10px] text-slate-500 font-mono tracking-wider flex justify-center gap-1">
              <kbd className="bg-slate-950 px-1.5 py-0.5 rounded border border-slate-800">Ctrl</kbd> + 
              <kbd className="bg-slate-950 px-1.5 py-0.5 rounded border border-slate-800">6</kbd>
            </div>
          )}
        </button>
      </div>
    </div>
  );
};

export default Home;